import { PathModule } from "app/common/LocalConst";
import { EgretLoadable } from "egret";

const StaffRouter = {
  path: PathModule.STAFF,
  exact: true,
  children: [
    {
      path: "working-schedule",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./WorkingSchedule/WorkingScheduleIndex"),
      }),
    },
    // {
    //     path: "staff-list",
    //     exact: true,
    //     component: EgretLoadable({ loader: () => import("./StaffList/StaffListIndex") })
    // },
    // {
    //     path: "staff-info",
    //     exact: true,
    //     component: EgretLoadable({ loader: () => import("./StaffList/StaffInfo") })
    // },
    {
      path: "timekeeping",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./Timekeeping/TimekeepingIndex"),
      }),
    },

    {
      path: "appointment-schedule",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./AppointmentSchedule/AppointmentScheduleIndex"),
      }),
    },
    {
      path: "schedule",
      exact: true,
      component: EgretLoadable({
        loader: () => import("./ScheduleStaff/ScheduleStaffIndex"),
      }),
    },
    {
      path: "embedded-iframe",
      exact: true,
      component: EgretLoadable({
        loader: () => import("app/EmbeddedIFrame/EmbeddedIFrameIndex"),
      }),
    },
  ],
};

export default StaffRouter;
